import { isBrowser } from '@publicss/utils';
import Cookies from 'js-cookie';

const USER_ID_COOKIE_NAME = 'CkUserId';

export function useUserCookies(): {
  userId?: string;
} {
  if (!isBrowser()) {
    return {};
  }

  let userId = Cookies.get(USER_ID_COOKIE_NAME) || null;

  if (!userId) {
    userId = window.crypto.randomUUID();
    Cookies.set(USER_ID_COOKIE_NAME, userId, {});
  }

  return { userId };
}
